import { axios } from './request'

export function http(url, method, data, token) {
  if (method.toUpperCase() == 'GET') {
    return axios({
      url: url,
      method: method,
      params: data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    })
  } else {
    return axios({
      url: url,
      method: method,
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }
}
